export class Mapping {
  static readonly AMOUNT = 'AMOUNT';
  static readonly AMOUNT_SHELF = 'AMOUNT_SHELF';
  static readonly AMOUNT_SHELF_MAX = 'AMOUNT_SHELF_MAX';
  static readonly AMOUNT_SHELF_MIN = 'AMOUNT_SHELF_MIN';
  static readonly AMOUNT_OF_CABINS = 'AMOUNT_OF_CABINS';
  static readonly CABIN_BOTTOM_HEIGHT = 'CABIN_BOTTOM_HEIGHT';
  static readonly CABIN_HEIGHT = 'CABIN_HEIGHT';
  static readonly WIDTH = 'WIDTH';
  static readonly WIDTH_MAX = 'WIDTH_MAX';
  static readonly WIDTH_MIN = 'WIDTH_MIN';
  static readonly DESIGN_OF_PRODUCT = 'DESIGN_OF_PRODUCT';
  static readonly DEPTH = 'DEPTH';
  static readonly DEPTH_EXISTING_CABINS = 'DEPTH_EXISTING_CABINS';
  static readonly DEPTH_MAX = 'DEPTH_MAX';
  static readonly DEPTH_MIN = 'DEPTH_MIN';
  static readonly SUGGESTION_ALIGNMENT_MIDDLE_FRONT =
    'SUGGESTION_ALIGNMENT_MIDDLE_FRONT';
  static readonly SUGGESTION_ALIGNMENT_BOTTOM_FRONT =
    'SUGGESTION_ALIGNMENT_BOTTOM_FRONT';
  static readonly FRONT_YES_NO = 'FRONT_YES_NO';
  static readonly FRONT_TOP = 'FRONT_TOP';
  static readonly FRONT_BOTTOM = 'FRONT_BOTTOM';
  static readonly AMOUNT_MIDDLE_FRONTS = 'AMOUNT_MIDDLE_FRONTS';
  static readonly HEIGHT_MIDDLE_FRONTS = 'HEIGHT_MIDDLE_FRONTS';
  static readonly HINGES_CC = 'HINGES_CC';
  static readonly HIGH_MIN_HEIGHT_FRONT = 'HIGH_MIN_HEIGHT_FRONT';
  static readonly RIGHT_LEFT = 'RIGHT_LEFT';
  static readonly HEIGHT = 'HEIGHT';
  static readonly HEIGHT_BLIND_FRONT = 'HEIGHT_BLIND_FRONT';
  static readonly HEIGHT_FRONT = 'HEIGHT_FRONT';
  static readonly HEIGHT_MAX = 'HEIGHT_MAX';
  static readonly HEIGHT_BETWEEN_CABINS_ROOF = 'HEIGHT_BETWEEN_CABINS_ROOF';
  static readonly HEIGHT_MIN = 'HEIGHT_MIN';
  static readonly HEIGHT_SPAREPART = 'HEIGHT_SPAREPART';
  static readonly HEIGHT_EXITING_CABINS = 'HEIGHT_EXITING_CABINS';
  static readonly INTERNAL_WIDTH = 'INTERNAL_WIDTH';
  static readonly INTERNAL_WIDTH_MAX = 'INTERNAL_WIDTH_MAX';
  static readonly INTERNAL_WIDTH_MIN = 'INTERNAL_WIDTH_MIN';
  static readonly INTERNAL_HEIGHT = 'INTERNAL_HEIGHT';
  static readonly INTERNAL_HEIGHT_MAX = 'INTERNAL_HEIGHT_MAX';
  static readonly INTERNAL_HEIGHT_MIN = 'INTERNAL_HEIGHT_MIN';
  static readonly BOTTOM_FRONT = 'BOTTOM_FRONT';
  static readonly MAPPING = 'MAPPING';
  static readonly HANDLES_YES_NO = 'HANDLES_YES_NO';
  static readonly TOP_FRONT = 'TOP_FRONT';
  static readonly TOP_FRONT_COVER = 'TOP_FRONT_COVER';
  static readonly BASE_HEIGHT = 'BASE_HEIGHT';
  static readonly BASE_HEIGHT_MAX = 'BASE_HEIGHT_MAX';
  static readonly BASE_HEIGHT_MIN = 'BASE_HEIGHT_MIN';
  static readonly COLUMN_COVERING = 'COLUMN_COVERING';
  static readonly STD_MIN_HEIGHT_FRONT = 'STD_MIN_HEIGHT_FRONT';
  static readonly CABINs_HEIGHT = 'CABINs_HEIGHT';
  static readonly COVER_CABIN = 'COVER_CABIN';
  static readonly CABIN_COVER_LEFT = 'CABIN_COVER_LEFT';
  static readonly CABIN_COVER_RIGHT = 'CABIN_COVER_RIGHT';
  static readonly TOTAL_WITHD = 'TOTAL_WITHD';
  static readonly TOTAL_FRONT_HEIGHT = 'TOTAL_FRONT_HEIGHT';
  static readonly HEATSHIELD_RIGHTSIDE = 'HEATSHIELD_RIGHTSIDE';
  static readonly HEATSHIELD_LEFTSIDE = 'HEATSHIELD_LEFTSIDE';
  static readonly FRONTS_MIDDLE_HEIGHT = 'FRONTS_MIDDLE_HEIGHT';
  static readonly FRONTS_MIDDLE_HEIGHT2 = 'FRONTS_MIDDLE_HEIGHT2';
  static readonly FRONTS_MIDDLE_HEIGHT3 = 'FRONTS_MIDDLE_HEIGHT3';
  static readonly FRONT_SPICERACK_TOP = 'FRONT_SPICERACK_TOP';
  static readonly FRONT_SPICERACK_BOTTOM = 'FRONT_SPICERACK_BOTTOM';
  static readonly TOP_BOTTOM = 'TOP_BOTTOM';
  static readonly COMMENTS = 'COMMENTS';
  static readonly DOUBLE_DOOR = 'DOUBLE_DOOR';
  static readonly HEIGHT_2 = 'HEIGHT_2';
  static readonly TOP_DOOR_HEIGHT = 'TOP_DOOR_HEIGHT';
  static readonly LIGHT_RAMP_YES_NO = 'LIGHT_RAMP_YES_NO';
  static readonly POSITIONNUMBER = 'POSITIONNUMBER';
  static readonly FICTIONAL_HEIGHT = 'FICTIONAL_HEIGHT';
  static readonly HINGES_CC_TOP = 'HINGES_CC_TOP';
  static readonly HINGES_CC_BOTTOM = 'HINGES_CC_BOTTOM';
  static readonly INTERNAL_WIDTH_LEFT = 'INTERNAL_WIDTH_LEFT';
  static readonly INTERNAL_WIDTH_RIGHT = 'INTERNAL_WIDTH_RIGHT';
  static readonly WIDTH_2 = 'WIDTH_2';
  static readonly HANDLE_PLACEMENT = 'HANDLE_PLACEMENT';
  static readonly HANDLE_LAT_HORZ = 'HANDLE_LAT_HORZ';
  static readonly COVERSIDE_PERSPECTIVE = 'COVERSIDE_PERSPECTIVE';
  static readonly HINGES_CC_TOP2 = 'HINGES_CC_TOP2';
  static readonly HINGES_CC_BOTTOM2 = 'HINGES_CC_BOTTOM2';
  static readonly STANDINGLAYING = 'STANDINGLAYING';
  static readonly HANDLES_TYPE = 'HANDLES_TYPE';
  static readonly HANDLES_YES = 'HANDLES_YES';
  static readonly GLOBAL_COMMENT = 'GLOBAL_COMMENT';
  static readonly HINGES_AMOUNT = 'HINGES_AMOUNT';
  static readonly CONNECTED_TO_POSITIONNUMBER = 'CONNECTED_TO_POSITIONNUMBER';
  static readonly DRAWER_1_DEPTH = 'DRAWER_1_DEPTH';
  static readonly DRAWER_2_DEPTH = 'DRAWER_2_DEPTH';
  static readonly DRAWER_3_DEPTH = 'DRAWER_3_DEPTH';
  static readonly DRAWER_4_DEPTH = 'DRAWER_4_DEPTH';
  static readonly DRAWER_5_DEPTH = 'DRAWER_5_DEPTH';
  static readonly HINGE_CC_EXTRA = 'HINGE_CC_EXTRA';
  static readonly EXTRA_HINGE = 'EXTRA_HINGE';
  static readonly BLINDFRONT_HANDLE = 'BLINDFRONT_HANDLE';
  static readonly BLINDFRONT_HANDLE_TOP = 'BLINDFRONT_HANDLE_TOP';
  static readonly BLINDFRONT_HANDLE_BOTTOM = 'BLINDFRONT_HANDLE_BOTTOM';
  static readonly CUT_OFF_TYPE = 'CUT_OFF_TYPE';
  static readonly CUT_OFF_PLACEMENT = 'CUT_OFF_PLACEMENT';
  static readonly DOOR_TYPE = 'DOOR_TYPE';
  static readonly TIPON1 = 'TIPON1';
}
